if (!customElements.get("hys-puc-swiper")) {
  customElements.define(
    "hys-puc-swiper",
    class hysPucSwiper extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector(".swiper");
        // this.clientWidth = window.innerWidth;
        this.isMobile = window.matchMedia("(max-width: 768px)").matches;
        this.prevBtn = this.closest(".hys-pdp-use-carousel").querySelector(
          ".swiper-button-prev"
        );
        this.nextBtn = this.closest(".hys-pdp-use-carousel").querySelector(
          ".swiper-button-next"
        );
        this.gap = (window.innerWidth * 32) / this.isMobile ? 440 : 1280;
        this.initSwiper();
      }
      initSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1.2,
          spaceBetween: 24,
          speed: 1000,
          breakpoints: {
            768: {
              slidesPerView: 2.2,
              spaceBetween: 32,
            },
          },
          navigation: {
            nextEl: this.nextBtn,
            prevEl: this.prevBtn,
          },
          autoplay: {
            delay: 2000,
            disableOnInteraction: true,
          },
        });
      }
    }
  );
}
